import React, { useEffect, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrash, faEdit, faSync, faPlus, faEye, faMinus } from '@fortawesome/free-solid-svg-icons';
import { toast } from 'react-toastify';
import Swal from 'sweetalert2';
import './RecetasData.css';
import baseURL from '../../url';
import moneda from '../../moneda';

export default function RecetasData() {
    const [recetas, setRecetas] = useState([]);
    const [productos, setProductos] = useState([]);
    const [articulos, setArticulos] = useState([]);
    const [modalVisible, setModalVisible] = useState(false);
    const [modalDetalleVisible, setModalDetalleVisible] = useState(false);
    const [recetaActual, setRecetaActual] = useState({});
    const [idProducto, setIdProducto] = useState('');
    const [ingredientes, setIngredientes] = useState([{ idArticulo: '', cantidad: '' }]);
    const [filtro, setFiltro] = useState('');

    useEffect(() => {
        cargarRecetas();
        cargarProductos();
        cargarArticulos();
    }, []);

    const cargarRecetas = () => {
        fetch(`${baseURL}/inventarioRecetasGet.php`)
            .then(response => response.json())
            .then(data => setRecetas(data.recetas || []))
            .catch(error => console.error('Error:', error));
    };

    const cargarProductos = () => {
        fetch(`${baseURL}/productosGet.php`)
            .then(response => response.json())
            .then(data => setProductos(data.productos || []))
            .catch(error => console.error('Error:', error));
    };

    const cargarArticulos = () => {
        fetch(`${baseURL}/inventarioArticulosGet.php`)
            .then(response => response.json())
            .then(data => setArticulos(data.articulos || []))
            .catch(error => console.error('Error:', error));
    };

    const abrirModalNuevo = () => {
        setRecetaActual({});
        setIdProducto('');
        setIngredientes([{ idArticulo: '', cantidad: '' }]);
        setModalVisible(true);
    };

    const abrirModalEditar = (receta) => {
        setRecetaActual(receta);
        setIdProducto(receta.idProducto);
        setIngredientes(receta.ingredientes.map(ing => ({
            idArticulo: ing.idArticulo,
            cantidad: ing.cantidad
        })));
        setModalVisible(true);
    };

    const cerrarModal = () => {
        setModalVisible(false);
    };

    const agregarIngrediente = () => {
        setIngredientes([...ingredientes, { idArticulo: '', cantidad: '' }]);
    };

    const eliminarIngrediente = (index) => {
        const nuevosIngredientes = ingredientes.filter((_, i) => i !== index);
        setIngredientes(nuevosIngredientes);
    };

    const actualizarIngrediente = (index, campo, valor) => {
        const nuevosIngredientes = [...ingredientes];
        nuevosIngredientes[index][campo] = valor;
        setIngredientes(nuevosIngredientes);
    };

    const guardarReceta = () => {
        if (!idProducto || ingredientes.length === 0) {
            toast.error('Debe seleccionar un producto y al menos un ingrediente');
            return;
        }

        const ingredientesValidos = ingredientes.filter(ing => ing.idArticulo && ing.cantidad);
        if (ingredientesValidos.length === 0) {
            toast.error('Debe agregar al menos un ingrediente válido');
            return;
        }

        if (recetaActual.idReceta) {
            // Editar
            const payload = { ingredientes: ingredientesValidos };
            fetch(`${baseURL}/inventarioRecetasPut.php?idReceta=${recetaActual.idReceta}`, {
                method: 'PUT',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(payload)
            })
                .then(response => response.json())
                .then(data => {
                    if (data.error) {
                        toast.error(data.error);
                    } else {
                        Swal.fire('¡Actualizado!', data.mensaje, 'success');
                        cargarRecetas();
                        cerrarModal();
                    }
                })
                .catch(error => toast.error(error.message));
        } else {
            // Crear
            const formData = new FormData();
            formData.append('idProducto', idProducto);
            formData.append('ingredientes', JSON.stringify(ingredientesValidos));

            fetch(`${baseURL}/inventarioRecetasPost.php`, {
                method: 'POST',
                body: formData
            })
                .then(response => response.json())
                .then(data => {
                    if (data.error) {
                        toast.error(data.error);
                    } else {
                        Swal.fire('¡Creado!', data.mensaje, 'success');
                        cargarRecetas();
                        cerrarModal();
                    }
                })
                .catch(error => toast.error(error.message));
        }
    };

    const eliminarReceta = (idReceta) => {
        Swal.fire({
            title: '¿Estás seguro?',
            text: '¡No podrás revertir esto!',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#D83098',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Sí, eliminar',
            cancelButtonText: 'Cancelar'
        }).then((result) => {
            if (result.isConfirmed) {
                fetch(`${baseURL}/inventarioRecetasDelete.php?idReceta=${idReceta}`, {
                    method: 'DELETE'
                })
                    .then(response => response.json())
                    .then(data => {
                        if (data.error) {
                            Swal.fire('Error', data.error, 'error');
                        } else {
                            Swal.fire('¡Eliminado!', data.mensaje, 'success');
                            cargarRecetas();
                        }
                    })
                    .catch(error => toast.error(error.message));
            }
        });
    };

    const verDetalle = (receta) => {
        setRecetaActual(receta);
        setModalDetalleVisible(true);
    };

    const recetasFiltradas = recetas.filter(item =>
        item.nombreProducto.toLowerCase().includes(filtro.toLowerCase())
    );

    const getUnidadArticulo = (idArticulo) => {
        const articulo = articulos.find(a => a.idArticulo == idArticulo);
        return articulo ? articulo.simboloUnidad : '';
    };

    const productosConReceta = recetas.map(r => Number(r.idProducto));
    const productosDisponibles = recetaActual.idReceta 
        ? productos 
        : productos.filter(p => !productosConReceta.includes(Number(p.idProducto)));

    return (
        <div>
            

            <div className='deFlexContent'>
                <button className='btnPost' onClick={abrirModalNuevo}>
                    <FontAwesomeIcon icon={faPlus} /> Agregar Receta
                </button>

                <div className='filtrosContain' style={{justifyContent: 'flex-end' }}>
                    <input
                        type="text"
                        placeholder="Buscar por producto"
                        value={filtro}
                        onChange={(e) => setFiltro(e.target.value)}
                        className='filtroInput'
                    />
                    
                </div>
            </div>

            {/* Modal Formulario */}
            {modalVisible && (
                <div className="modal">
                    <div className="modal-content">
                        <div className='deFlexBtnsModal'>
                            <h3>{recetaActual.idReceta ? 'Editar Receta' : 'Nueva Receta'}</h3>
                            <span className="close" onClick={cerrarModal}>&times;</span>
                        </div>

                        <fieldset>
                            <legend>Producto</legend>
                            <select 
                                value={idProducto} 
                                onChange={(e) => setIdProducto(e.target.value)}
                                disabled={recetaActual.idReceta}
                            >
                                <option value="">Seleccione un producto</option>
                                {productosDisponibles.map(prod => (
                                    <option key={prod.idProducto} value={prod.idProducto}>
                                        {prod.titulo}
                                    </option>
                                ))}
                            </select>
                        </fieldset>

                        <h4 style={{ marginTop: '20px' }}>Ingredientes</h4>
                        <div className='ingredientesContainer'>
                            {ingredientes.map((ingrediente, index) => (
                                <div key={index} className='ingredienteItem'>
                                    <select
                                        value={ingrediente.idArticulo}
                                        onChange={(e) => actualizarIngrediente(index, 'idArticulo', e.target.value)}
                                    >
                                        <option value="">Seleccione ingrediente</option>
                                        {articulos.map(art => (
                                            <option key={art.idArticulo} value={art.idArticulo}>
                                                {art.nombre}
                                            </option>
                                        ))}
                                    </select>
                                    <input
                                        type="number"
                                        step="0.01"
                                        placeholder="Cantidad"
                                        value={ingrediente.cantidad}
                                        onChange={(e) => actualizarIngrediente(index, 'cantidad', e.target.value)}
                                    />
                                    <span className='unidadLabel'>{getUnidadArticulo(ingrediente.idArticulo)}</span>
                                    {ingredientes.length > 1 && (
                                        <button className='eliminar' onClick={() => eliminarIngrediente(index)}>
                                            <FontAwesomeIcon icon={faMinus} />
                                        </button>
                                    )}
                                </div>
                            ))}
                        </div>
                        <button className='btnAgregar' onClick={agregarIngrediente}>
                            <FontAwesomeIcon icon={faPlus} /> Agregar otro ingrediente
                        </button>

                        <button className='btnPost' onClick={guardarReceta}>Guardar</button>
                    </div>
                </div>
            )}

            {/* Modal Detalle */}
            {modalDetalleVisible && (
                <div className="modal">
                    <div className="modal-content">
                        <div className='deFlexBtnsModal'>
                            <h3>Detalle de Ingredientes - {recetaActual.nombreProducto}</h3>
                            <span className="close" onClick={() => setModalDetalleVisible(false)}>&times;</span>
                        </div>

                        <div className='table-container'>
                            <table className='table'>
                                <thead>
                                    <tr>
                                        <th>Ingrediente</th>
                                        <th>Cantidad</th>
                                        <th>Unidad</th>
                                        <th>Costo</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {recetaActual.ingredientes && recetaActual.ingredientes.map((ing, index) => (
                                        <tr key={index}>
                                            <td>{ing.nombreArticulo}</td>
                                            <td>{ing.cantidad}</td>
                                            <td>{ing.simboloUnidad}</td>
                                            <td style={{ color: '#008000' }}>
                                                {moneda} {`${ing.costoIngrediente}`.replace(/\B(?=(\d{3})+(?!\d))/g, ".")}
                                            </td>
                                        </tr>
                                    ))}
                                    <tr style={{ fontWeight: 'bold' }}>
                                        <td colSpan="3">Costo Total:</td>
                                        <td style={{ color: '#008000' }}>
                                            {moneda} {`${recetaActual.costoTotal}`.replace(/\B(?=(\d{3})+(?!\d))/g, ".")}
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            )}

            {/* Tabla de Recetas */}
            <div className='table-container'>
                <table className='table'>
                    <thead>
                        <tr>
                            <th>Imagen</th>
                            <th>Producto</th>
                            <th>Categoría</th>
                            <th>Costo Total</th>
                            <th>Acciones</th>
                        </tr>
                    </thead>
                    <tbody>
                        {recetasFiltradas.map(item => (
                            <tr key={item.idReceta}>
                                <td>
                                    {item.imagenProducto ? (
                                        <img src={item.imagenProducto} alt={item.nombreProducto} />
                                    ) : (
                                        <span className='imgNonetd'>Sin imagen</span>
                                    )}
                                </td>
                                <td>{item.nombreProducto}</td>
                                <td>{item.categoriaProducto || '-'}</td>
                                <td style={{ color: '#008000' }}>
                                    {moneda} {`${item.costoTotal}`.replace(/\B(?=(\d{3})+(?!\d))/g, ".")}
                                </td>
                                <td>
                                    <button className='editar2' onClick={() => verDetalle(item)}>
                                        <FontAwesomeIcon icon={faEye} />
                                    </button>
                                    <button className='editar' onClick={() => abrirModalEditar(item)}>
                                        <FontAwesomeIcon icon={faEdit} />
                                    </button>
                                    <button className='eliminar' onClick={() => eliminarReceta(item.idReceta)}>
                                        <FontAwesomeIcon icon={faTrash} />
                                    </button>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
}





